import { cn } from "@/lib/utils";
import { forwardRef } from "react";
import { useTranslation } from "react-i18next";
import { Badge } from "./Badge";
import Spinner from "./Spinner";

const variants = {
  0: {
    title: "order_status.failed",
    variant: "destructive",
    className: "",
  },
  1: {
    title: "order_status.success",
    variant: "success",
    className: "",
  },
  2: {
    title: "order_status.pending",
    variant: "secondary",
    className: "",
  },
  3: {
    title: "order_status.sabbaqli",
    variant: "",
    className:
      "bg-orange-600 hover:bg-orange-700 text-white border-transparent",
  },
  4: {
    title: "order_status.scheduled",
    variant: "",
    className: "bg-sky-500 hover:bg-sky-600 text-white border-transparent",
  },
};

const OrderStatus = forwardRef(
  ({ className, spinnerClassName, status, ...props }, ref) => {
    const { t } = useTranslation("ui-components");

    if (status === 2)
      return (
        <Spinner ref={ref} className={cn("w-7 h-7 ms-1", spinnerClassName)} />
      );

    const {
      title,
      variant: badgeVariant,
      className: badgeClassName,
    } = variants[status];

    return (
      <Badge
        ref={ref}
        className={cn("ms-1 capitalize", badgeClassName, className)}
        variant={badgeVariant}
        {...props}
      >
        {t(title)}
      </Badge>
    );
  }
);

OrderStatus.displayName = "OrderStatus";

export default OrderStatus;
